import WebFont from 'webfontloader';

const FontLoader = (font:string, onLoaded:(font:string) => void) => {
    WebFont.load({
        google: {
            families: [font]
        },
        fontactive:(familyName) => {
            onLoaded(familyName);
        }
    });
};

export default FontLoader;